



































































































































































import { Component, Emit, Prop, PropSync, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import IconBibliography from '@/components/molecules/IconBibliography/IconBibliography.vue'
import {
  BibliographyClass,
  BibliographyFullId,
  CollectionFlag,
  Prefix,
  SearchType
} from '@/types'
import { defaultSystemCode, SystemCode } from '@/api'
import { InputCollectionNo } from '@/components/molecules/InputCollectionNo'

export interface BookbindingCollectionInfoItem {
  collectionId: number
  collectionNo: {
    input: string
    errorMessage: string
  }
  bibliographyClass: BibliographyClass
  prefix: Prefix
  bibliographyId: number
  searchType: SystemCode
  displayTitle: string
  displayAuthor: string
  displayPublisher: string
  volume: string
  volumeNumber: string
  volumeTotal: string
  volumeDateLabel: string
  volumeSpecial: string
  collectionFlag: CollectionFlag
  revision: number
}

export const defaultBookbindingCollectionInfoItem = (): BookbindingCollectionInfoItem => ({
  collectionId: 0,
  collectionNo: {
    input: '',
    errorMessage: ''
  },
  bibliographyClass: BibliographyClass.Real,
  prefix: Prefix.Real,
  bibliographyId: 0,
  searchType: defaultSystemCode(),
  displayTitle: '',
  displayAuthor: '',
  displayPublisher: '',
  volume: '',
  volumeNumber: '',
  volumeTotal: '',
  volumeDateLabel: '',
  volumeSpecial: '',
  collectionFlag: CollectionFlag.NotCollection,
  revision: 0
})

@Component({
  components: { InputCollectionNo, IconBibliography }
})
export default class BookbindingCollectionInfo extends ComponentVue {
  @Ref()
  inputCollectionNo!: InputCollectionNo

  @PropSync('item', {
    type: Object,
    required: true
  })
  infoItem!: BookbindingCollectionInfoItem

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean

  get isSearchTypeMagazine(): boolean {
    return this.infoItem.searchType.code === SearchType.Magazine
  }

  focusCollectionNo(): void {
    this.inputCollectionNo.focus()
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  isCollectionFlagCollection(collectionFlag: CollectionFlag): boolean {
    return collectionFlag === CollectionFlag.Collection
  }

  @Emit('title')
  onClickTitle(): BibliographyFullId {
    return {
      prefix: this.infoItem.prefix,
      id: this.infoItem.bibliographyId
    }
  }

  @Emit('search')
  onClickSearch(): void {}

  @Emit('determine:collection-no')
  onDetermineCollectionNo(): void {}
}
